import React from "react";

// Star of Life (blue 6-spoked asterisk) + PACEMIA wordmark
export function Logo({ size = 34, showText = true, className = "" }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <StarOfLife size={size} />
      {showText && (
        <div className="flex flex-col leading-none">
          <span className="font-display font-extrabold tracking-tight text-foreground" style={{ fontSize: size * 0.62 }}>
            PACE<span className="text-primary">MIA</span>
          </span>
          <span
            className="mt-[3px] font-bold uppercase text-amber-500 dark:text-amber-400"
            style={{ fontSize: Math.max(8, size * 0.26), letterSpacing: "0.22em" }}
            data-testid="beta-tag"
          >
            Beta
          </span>
        </div>
      )}
    </div>
  );
}

export function StarOfLife({ size = 34 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Étoile de Vie">
      <g transform="translate(50,50)">
        {[0, 60, 120].map((deg) => (
          <rect
            key={deg}
            x="-9"
            y="-44"
            width="18"
            height="88"
            rx="9"
            fill="currentColor"
            className="text-primary"
            transform={`rotate(${deg})`}
          />
        ))}
        <circle r="11" fill="white" className="dark:fill-[#0a0a0a]" />
      </g>
    </svg>
  );
}
